export const statusMessageTokens = {
  'status-padding': 'var(--dp-spacing-md)',
  'status-border-radius': 'var(--dp-border-radius-md)',
  'status-font-size': 'var(--dp-font-size-md)',
  'status-icon-size': '20px',
  'status-icon-gap': 'var(--dp-spacing-sm)',
  'status-success-bg': 'var(--dp-color-success-light)',
  'status-success-border': 'var(--dp-color-success)',
  'status-success-text': 'var(--dp-color-success-dark)',
  'status-warning-bg': 'var(--dp-color-warning-light)',
  'status-warning-border': 'var(--dp-color-warning)',
  'status-warning-text': 'var(--dp-color-warning-dark)',
  'status-error-bg': 'var(--dp-color-error-light)',
  'status-error-border': 'var(--dp-color-error)',
  'status-error-text': 'var(--dp-color-error-dark)',
  'status-info-bg': 'var(--dp-color-info-light)',
  'status-info-border': 'var(--dp-color-info)',
  'status-info-text': 'var(--dp-color-info-dark)',
} as const;
